import { StepContainer } from '../components/StepContainer'
import { SingleSelect } from '../components/SingleSelect'
import { useOnboardingStore } from '../store/onboardingStore'
import type { FeaturePriority } from '../types/onboarding'

const options: { value: FeaturePriority; label: string; emoji: string; description: string }[] = [
  { value: 'meal_scanning', label: 'AI Meal Scanning', emoji: '📸', description: 'Snap a photo to check any meal' },
  { value: 'recipes', label: 'Kidney-Safe Recipes', emoji: '👨‍🍳', description: '100+ filtered recipes for your stage' },
  { value: 'tracking', label: 'Nutrient Tracking', emoji: '📊', description: 'Track sodium, potassium, phosphorus daily' },
  { value: 'restaurant_guide', label: 'Restaurant Guide', emoji: '🍽️', description: 'Know what to order when eating out' },
  { value: 'education', label: 'Learn About My Diet', emoji: '📚', description: 'Understand what to eat and why' },
  { value: 'fluid_tracking', label: 'Fluid Tracking', emoji: '💧', description: 'Monitor daily fluid intake' },
]

export function FeaturePriorityStep() {
  const { data, goNext } = useOnboardingStore()

  return (
    <StepContainer
      title="What feature excites you most?"
      subtitle="We'll prioritize this in your setup"
      showContinue={false}
    >
      <SingleSelect
        options={options}
        value={data.featurePriority}
        onChange={(value) => goNext({ featurePriority: value })}
      />
    </StepContainer>
  )
}
